module.exports = __webpack_public_path__ + "img/picture-2.3dda95ed.png";